module.exports = __webpack_public_path__ + "media/fundraising_sim/plus_img02-bbe11b47.png";